import TimelineFeedCont from '../../../components/Common/TimelineFeed/TimelineFeedCont'
import AccountsCont from '../../../components/People/Accounts/AccountsCont'
import CustomSpin from '../../../elements/CustomSpin'
import PageTitle from '../../../elements/PageTitle'
import React from 'react'
import { Breadcrumb, Card, Icon, Layout, Row, Tabs } from 'antd'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'
import Details from './Details'
import Profile from './Profile'
import Banking from '../../People/Member/Banking'
import Contracts from './Contracts'
import Documents from '../../Common/Documents/DocumentsCont'
import ClientDetails from './ClientDetails'
import Users from '../../../components/Sales/Client/Users'
import CatalogsCont from '../../../components/Common/Catalogs/CatalogsCont'

const { Content } = Layout
const { TabPane } = Tabs

function Client (props) {
  const {
    member,
    fetch,
    client,
    repsList,
    memberFetching,
    clientFetching,
    repsListFetching,
  } = props
  return (
    <CustomSpin spinning={memberFetching}>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Sales</Breadcrumb.Item>
              <Breadcrumb.Item href="#/clients/list">Clients List</Breadcrumb.Item>
              <Breadcrumb.Item>{member.fn}</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Client Management Area'}
              subtitle={'Client Management Area.'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>

        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Details {...{ client, member }} />
            <Row style={{ paddingTop: '10px' }}>
              <Tabs
                defaultActiveKey={get(props, 'location.hash') || '#profile'}
                onChange={key => props.history.push(key)}>
                <TabPane
                  tab={
                    <span>
                      <Icon type="user"/>
                      Profile
                    </span>
                  }
                  key="#profile">
                  <Profile {...{ repsList, member, fetching: repsListFetching, fetch }} />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle-o"/>
                      Client Details
                    </span>
                  }
                  key="#details">
                  <ClientDetails {...props} loading={clientFetching}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="bank"/>
                      Banking Details
                    </span>
                  }
                  key="#bank">
                  <Banking member={member} employee={client}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="form"/>
                      Accounts
                    </span>
                  }
                  key="#accounts">
                  <Contracts loading={clientFetching} client={client} member={member}/>
                </TabPane>
                <TabPane
                  disabled
                  tab={
                    <span>
                      <Icon type="lock"/>
                      Access
                    </span>
                  }
                  key="#access">
                  <AccountsCont/>
                  <Users loading={memberFetching} member={member}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="windows"/> Products
                    </span>
                  }
                  key="#products">
                  <CatalogsCont member={member}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open"/>
                      Documents
                    </span>
                  }
                  key="#docs">
                  <Documents owner={client}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="file-text"/>
                      Notes
                    </span>
                  }
                  key="#note">
                  <TimelineFeedCont owner={client._id} hideNotification={true}/>
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Row>
      </Content>
    </CustomSpin>
  )
}

export default withRouter(Client)
